import React from 'react';
import { motion } from 'framer-motion';
import {
  AcademicCapIcon,
  UserGroupIcon,
  UserIcon,
  BuildingOffice2Icon,
  PencilSquareIcon
} from '@heroicons/react/24/outline';

const InvSlide07Users: React.FC = () => {
  const users = [
    {
      icon: AcademicCapIcon,
      title: 'Students',
      desc: 'Gamified learning path, XP, streaks, achievements',
      note: 'Solo high school signups or via parent/school',
      color: '#0ea5e9',
    },
    {
      icon: UserIcon,
      title: 'Parents',
      desc: 'Monitor progress, home rewards, activity tracking',
      note: 'Sign up on behalf of children',
      color: '#10b981',
    },
    {
      icon: UserGroupIcon,
      title: 'Teachers',
      desc: 'Classroom management, homework, quizzes, scheduling',
      note: 'Trial directly in their classroom',
      color: '#f59e0b',
    },
    {
      icon: BuildingOffice2Icon,
      title: 'Schools',
      desc: 'Bulk enrollment, analytics, district benchmarking',
      note: 'Enterprise pricing and SSO integration',
      color: '#8b5cf6',
    },
    {
      icon: PencilSquareIcon,
      title: 'Content Creators',
      desc: 'Create custom courses for music, geography, etc.',
      note: 'Marketplace for add-on subjects',
      color: '#ec4899',
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-3 text-center"
      >
        Five User Types, One Platform
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-xl text-[#94a3b8] mb-10 text-center"
      >
        An all-in-one learning platform connecting students, parents, teachers, and schools
      </motion.p>

      <div className="flex gap-5 max-w-6xl">
        {users.map((user, index) => (
          <motion.div
            key={user.title}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
            className="flex-1 flex flex-col items-center text-center p-5 rounded-xl"
            style={{
              background: `${user.color}10`,
              border: `1px solid ${user.color}30`,
            }}
          >
            <div
              className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4"
              style={{
                background: `${user.color}20`,
                border: `2px solid ${user.color}50`,
              }}
            >
              <user.icon className="w-8 h-8" style={{ color: user.color }} />
            </div>
            <h3 className="text-xl font-semibold text-white mb-2">{user.title}</h3>
            <p className="text-sm text-[#94a3b8] mb-3 flex-1">{user.desc}</p>
            <div
              className="text-xs px-3 py-1 rounded-full"
              style={{ background: `${user.color}15`, color: user.color }}
            >
              {user.note}
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9 }}
        className="mt-10 flex items-center gap-8"
      >
        <div
          className="px-6 py-4 rounded-xl text-center"
          style={{
            background: 'rgba(14, 165, 233, 0.15)',
            border: '1px solid rgba(14, 165, 233, 0.3)',
          }}
        >
          <p className="text-lg text-white">
            <span className="font-bold text-[#0ea5e9]">Content Marketplace:</span> Third-party subjects as add-ons
          </p>
        </div>
        <div
          className="px-6 py-4 rounded-xl text-center"
          style={{
            background: 'rgba(16, 185, 129, 0.15)',
            border: '1px solid rgba(16, 185, 129, 0.3)',
          }}
        >
          <p className="text-lg text-white">
            <span className="font-bold text-[#10b981]">Profile follows you:</span> K-12, school to school
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default InvSlide07Users;
